import React, { useEffect, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import utils from "../../resources/utils";
import constant from "../../resources/constant";
import _ from "lodash";
import Footer from "../../Footer";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const { user_details } = useSelector((state) => state.app, shallowEqual);
  const navigate = useNavigate();
  const [is_edit, set_is_edit] = useState(false);
  const [profile, setProfile] = useState();
  const selected_business = utils._retrieveData(constant.SELECTED_BUSINESS);
  const selected_language_raw = utils._retrieveData(constant.SELECTED_LANGUAGE);
  let selected_language = '';
  if (selected_language_raw) {
    if (typeof selected_language_raw === 'string') {
      selected_language = selected_language_raw.split('-')[0];
    } else if (typeof selected_language_raw === 'object' && selected_language_raw.code) {
      selected_language = selected_language_raw.code.split('-')[0];
    }
  }
  const { t } = useTranslation();

  useEffect(() => {
    const user_data = utils._retrieveData(constant.USER_DETIALS);
    setProfile(user_data);
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
  };

  const handle_go_back = () => {
    navigate(-1);
  };

  const handle_edit = () => {
    set_is_edit(!is_edit);
  };

  return (
    <div className="px-6 mt-10">
      <div className="flex items-center gap-2 " onClick={handle_go_back}>
        <img src={ImageLinks.chevron_right} className="w-[18px] h-[19px]" alt="Back" />
        <p className="font-custom text-sm font-semibold text-dark_black">
          {t("profile")}
        </p>
      </div>
      {/* <div
        className="flex justify-end gap-2 items-center mt-[60px]"
        onClick={handle_edit}
        style={{ visibility: is_edit ? "hidden" : "" }}
      >
        <img src={ImageLinks.edit_sky_blue} className="w-[14px] h-[14px]" />
        <p className="font-custom text-sm font-semibold text-secondary">
          Edit details
        </p>
      </div> */}
      <div className="relative rounded-lg bg-white shadow-[0px_0px_8px_rgba(166,166,166,0.25)] p-6 mt-2 pb-[40px] mt-[60px]">
        <div
          className="absolute rounded-full border border-secondary top-[-30px]"
          style={{
            width: "66px",
            height: "66px",
          }}
        >
          <img loading="lazy" src={ImageLinks.default_profile} alt="" />
        </div>
        <div className="flex flex-col gap-8 mt-10">
          <div className="flex gap-4 items-baseline">
            <div className={`h-2 w-2 rounded-full bg-secondary`}></div>
            <div className="flex w-full gap-2 overflow-hidden	">
              <div className="flex flex-col gap-1 w-[50%]">
                <p className="font-custom text-xs font-medium text-dark_gray">
                  {t("first_name")}
                </p>
                {is_edit ? (
                  <input
                    type="text"
                    value={"Rushil"}
                    // onChange={handleInputChange}
                    className="font-custom font-bold border border-accents text-dark_black text-sm rounded-lg  p-1 px-4 py-1.5 pl-2 focus:outline-accents "
                  />
                ) : (
                  <p className="font-custom text-sm font-bold text-dark_black">
                    {profile?.first_name}
                  </p>
                )}
              </div>
              <div className="flex flex-col gap-1 w-[50%]">
                <p className="font-custom text-xs font-medium text-dark_gray">
                  {t("last_name")}
                </p>
                {is_edit ? (
                  <input
                    type="text"
                    id="saveAddress"
                    name="saveAddress"
                    value={"Mohan"}
                    // onChange={handleInputChange}
                    className="font-custom font-bold  border border-accents text-dark_black text-sm rounded-lg  p-1 px-4 py-1.5 pl-2 w-full focus:outline-accents"
                  />
                ) : (
                  <p className="font-custom text-sm font-bold text-dark_black">
                    {profile?.last_name}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="flex gap-4 items-baseline">
            <div className={`h-2 w-2 rounded-full bg-secondary`}></div>
            <div className="flex flex-col gap-1 w-[80%]">
              <p className="font-custom text-xs font-medium text-dark_gray">
                {t("your_email")}
              </p>
              {is_edit ? (
                <input
                  type="text"
                  value={"rushilmohan@pidge.in"}
                  // onChange={handleInputChange}
                  className="font-custom font-bold  border border-accents text-dark_black text-sm rounded-lg  p-1 px-4 py-1.5 pl-2 focus:outline-accents"
                  placeholder={t("email")}
                />
              ) : (
                <p className="font-custom text-sm font-bold text-dark_black">
                  {profile?.email}
                </p>
              )}
            </div>
          </div>
          <div className="flex gap-4 items-baseline">
            <div className={`h-2 w-2 rounded-full bg-secondary`}></div>
            <div className="flex flex-col gap-1 w-[47%]">
              <p className="font-custom text-xs font-medium text-dark_gray">
                {t("your_contact")}
              </p>
              {is_edit ? (
                <input
                  type="text"
                  value={"8891237610"}
                  // onChange={handleInputChange}
                  className="font-custom font-bold border border-accents text-dark_black text-sm rounded-lg  p-1 px-4 py-1.5 pl-2 focus:outline-accents"
                  placeholder={"your_contact"}
                />
              ) : (
                <p className="font-custom text-sm font-bold text-dark_black">
                  {profile?.mobile}
                </p>
              )}
            </div>
          </div>
          <div className="border-b border-light_gray my-[-14px]"></div>
          <div className="flex gap-4 items-baseline">
            <div className={`h-2 w-2 rounded-full bg-secondary`}></div>
            <div className="flex justify-between w-full items-center">
              <div className="flex flex-col gap-1">
                <p className="font-custom text-xs font-medium text-dark_gray">
                  {t("merchant_acc")}
                </p>
                <div>
                  <p className="font-custom text-sm font-bold text-dark_black">
                    {selected_business?.business_name ||
                      selected_business?.brand_name}{" "}
                  </p>
                  <p className="font-custom text-[10px] font-semibold text-dark_black">
                    ({selected_business?.business_id})
                  </p>
                </div>
              </div>
              <button
                className={`btn btn-outline border-secondary rounded-full btn-xs w-[52px]`}
                onClick={() => navigate("/business-select")}
              >
                <p
                  className={`font-custom font-semibold text-secondary text-[10px]`}
                >
                  {t("switch")}
                </p>
              </button>
            </div>
          </div>
          <div className="border-b border-light_gray my-[-14px]"></div>
          <div className="flex gap-4 items-baseline">
            <div className={`h-2 w-2 rounded-full bg-secondary`}></div>
            <div className="flex justify-between w-full items-center">
              <div className="flex flex-col gap-1">
                <p className="font-custom text-xs font-medium text-dark_gray">
                  {t("language")}
                </p>
                <div>
                  <p className="font-custom text-sm font-bold text-dark_black">
                    {['id', 'in'].includes(selected_language) ? 'Bahasa Indonesia' : 'English'}
                  </p>
                  <p className="font-custom text-[10px] font-semibold text-dark_black">
                    ({selected_language === 'in' ? 'id' : (selected_language || 'en')})
                  </p>
                </div>
              </div>
              <button
                className={`btn btn-outline border-secondary rounded-full btn-xs w-[52px]`}
                onClick={() => navigate("/language-select")}
              >
                <p
                  className={`font-custom font-semibold text-secondary text-[10px]`}
                >
                  {t("switch")}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {is_edit && (
        <div className="mt-8 px-6">
          <button
            onClick={() => set_is_edit(false)}
            className="font-custom btn btn-block bg-primary text-white cursor-not-allowed rounded-[30px] text-base font-semibold"
          >
            {t("update_details")}
          </button>
        </div>
      )}
    </div>
  );
};

export default Profile;
